export default __webpack_public_path__ + "static/media/impactofinjuries.30e48a2e.jpg";